module.exports = __webpack_public_path__ + "2952eed992c144dd703d366b4cfa1504.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/welcome-images/images/welcome-diamond-pattern-left.png
// module id = 335
// module chunks = 0